<template>
  <div>
    <h1>Configure Comparison Widget</h1>
    <el-form
      ref="form"
      :rules="rules"
      :model="form"
      size="small"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Title"
            prop="title"
          >
            <el-input
              v-model="form.title"
              placeholder="Title"
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Date Range"
            prop="dateRange"
          >
            <el-select
              v-model="form.dateRange"
              placeholder="Please select a date range"
              class="w-100"
            >
              <el-option
                label="Week to Date"
                value="week"
              />
              <el-option
                label="Month to Date"
                value="month"
              />
              <el-option
                label="Year to Date"
                value="year"
              />
              <el-option
                label="Fixed Date Range"
                value="fixed"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.dateRange === 'fixed'">
        <el-col>
          <el-form-item
            label="Fixed Date Range"
            prop="fixedDateRange"
          >
            <el-date-picker
              v-model="form.fixedDateRange"
              type="daterange"
              format="dd/MM/yyyy"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              class="w-100"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Chart A"
            prop="chartA"
          >
            <el-select
              v-model="form.chartA"
              placeholder="Please select Chart A"
              class="w-100"
            >
              <el-option
                v-for="(a, index) in chartAList"
                :key="index"
                :label="a"
                :value="a"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Chart B"
            prop="chartB"
          >
            <el-select
              v-model="form.chartB"
              placeholder="Please select Chart B"
              class="w-100"
            >
              <el-option
                v-for="(b, index) in chartBList"
                :key="index"
                :label="b"
                :value="b"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="mt-3 mb-3">
        <el-col>
          <el-switch
            v-model="groupBySwitch"
            active-color="#28a745"
            inactive-color="#2e7bcc"
            active-text="Group By Time"
            inactive-text="Group By Filter"
          />
        </el-col>
      </el-row>
      <el-row v-if="groupBySwitch">
        <el-col>
          <el-form-item
            label="Time Break Down"
            prop="timeBreakDown"
          >
            <el-select
              v-model="form.timeBreakDown"
              placeholder="Please select a time break down"
              class="w-100"
            >
              <el-option
                label="By Day"
                value="Day"
              />
              <el-option
                label="By Week"
                value="Week"
              />
              <el-option
                label="By Month"
                value="Month"
              />
              <el-option
                label="By Year"
                value="Year"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!groupBySwitch">
        <el-col>
          <el-form-item
            label="Filter"
            prop="filter"
          >
            <el-select
              v-model="form.filter"
              placeholder="Please select a filter"
              class="w-100"
            >
              <el-option
                v-for="filter in filters"
                :key="filter"
                :label="filter"
                :value="filter"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Chart Type"
            prop="chartType"
          >
            <el-select
              v-model="form.chartType"
              placeholder="Please select a chart type"
              class="w-100"
            >
              <el-option
                v-for="type in availableTypes"
                :key="type.value"
                :label="type.label"
                :value="type.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="!$route.params.accountId">
        <el-col>
          <el-form-item
            label="Accounts"
            prop="accounts"
          >
            <el-select
              v-model="form.accounts"
              multiple
              filterable
              remote
              value-key="id"
              placeholder="Please enter a account name"
              class="w-100"
              :remote-method="remoteMethodAccount"
              :loading="isLoadingAccounts"
            >
              <el-option
                v-for="item in accounts"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item
            label="Carriers"
            prop="carriers"
          >
            <el-select
              v-model="form.carriers"
              multiple
              filterable
              remote
              value-key="id"
              placeholder="Please enter a carrier name"
              class="w-100"
              :remote-method="remoteMethodCarrier"
              :loading="isLoadingCarriers"
            >
              <el-option
                v-for="item in carriers"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      form: {
        title: 'Comparison'
      },
      accounts: [],
      isLoadingAccounts: false,
      carriers: [],
      isLoadingCarriers: false,
      groupBySwitch: false,
      availableTypes: [
        { label: 'Line', value: 'Line' },
        { label: 'Area', value: 'Area' },
        { label: 'Bar', value: 'Bar' },
        { label: 'Pie', value: 'Pie' }
      ],
      filters: ['By State', 'By Lane', 'By Carrier', 'By Service', 'By Branch'],
      chartAList: ['Consignments', 'Items', 'Cube', 'Weight', 'Billed', 'Estimated'],
      chartBList: ['Consignments', 'Items', 'Cube', 'Weight', 'Billed', 'Estimated'],
      isResizable: true,
      rules: {
        title: [
          { required: true, message: 'Title of widget is required', trigger: 'blur' }
        ],
        dateRange: [
          { required: true, message: 'Date Range of widget is required', trigger: 'change' }
        ],
        fixedDateRange: [
          { required: true, message: 'Fixed Date Range of widget is required', trigger: 'change' }
        ],
        chartA: [
          { required: true, message: 'Chart A of widget is required', trigger: 'change' }
        ],
        chartB: [
          { required: true, message: 'Chart B of widget is required', trigger: 'change' }
        ],
        chartType: [
          { required: true, message: 'Type of widget is required', trigger: 'change' }
        ],
        filter: [
          { required: true, message: 'Filter of widget is required', trigger: 'change' }
        ],
        timeBreakDown: [
          { required: true, message: 'Time Break Down of widget is required', trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    submit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let widget = this.getFormattedWidget()
          this.$emit('submitted', widget)
        }
      })
    },
    getFormattedWidget () {
      return {
        name: this.form.chartA,
        configuration: {
          title: this.form.title,
          chartType: this.form.chartType,
          isResizable: this.isResizable,
          timeBreakDown: this.form.timeBreakDown || '',
          report: this.getReportByChart(this.form.chartA),
          xKey: this.getXKeyByFilter(this.form.filter),
          yKey: this.getYKeyByChart(this.form.chartA),
          params: {
            dateFrom: this.form.dateRange === 'fixed' ? this.$moment(this.form.fixedDateRange[0]).format('YYYY-MM-DD') : this.form.dateRange,
            dateTo: this.form.dateRange === 'fixed' ? this.$moment(this.form.fixedDateRange[1]).format('YYYY-MM-DD') : 'today',
            accountId: this.form.accounts.map(a => a.id).slice(','),
            carrierId: this.form.carriers.map(c => c.id).slice(','),
            showBilledOnly: this.form.chartA === 'Billed',
            internalConsOnly: true,
            carrierBreakDown: this.form.filter === 'By Carrier',
            zone: this.form.filter === 'By Lane',
            carrierService: this.form.filter === 'By Service',
            state: this.form.filter === 'By State',
            branchBreakDown: this.form.filter === 'By Branch',
            dayBreakDown: this.form.timeBreakDown === 'Day',
            weekBreakDown: this.form.timeBreakDown === 'Week',
            monthBreakDown: this.form.timeBreakDown === 'Month',
            yearBreakDown: this.form.timeBreakDown === 'Year'
          },
          comparing: [
            {
              name: this.form.chartB,
              configuration: {
                title: this.form.title,
                chartType: this.form.chartType,
                isResizable: this.isResizable,
                timeBreakDown: this.form.timeBreakDown || '',
                report: this.getReportByChart(this.form.chartB),
                xKey: this.getXKeyByFilter(this.form.filter),
                yKey: this.getYKeyByChart(this.form.chartB),
                params: {
                  dateFrom: this.form.dateRange === 'fixed' ? this.$moment(this.form.fixedDateRange[0]).format('YYYY-MM-DD') : this.form.dateRange,
                  dateTo: this.form.dateRange === 'fixed' ? this.$moment(this.form.fixedDateRange[1]).format('YYYY-MM-DD') : 'today',
                  accountId: this.form.accounts.map(a => a.id).slice(','),
                  carrierId: this.form.carriers.map(c => c.id).slice(','),
                  showBilledOnly: this.form.chartB === 'Billed',
                  internalConsOnly: true,
                  carrierBreakDown: this.form.filter === 'By Carrier',
                  zone: this.form.filter === 'By Lane',
                  carrierService: this.form.filter === 'By Service',
                  state: this.form.filter === 'By State',
                  branchBreakDown: this.form.filter === 'By Branch',
                  dayBreakDown: this.form.timeBreakDown === 'Day',
                  weekBreakDown: this.form.timeBreakDown === 'Week',
                  monthBreakDown: this.form.timeBreakDown === 'Month',
                  yearBreakDown: this.form.timeBreakDown === 'Year'
                }
              }
            }
          ]
        }
      }
    },
    getXKeyByFilter (filter) {
      switch (filter) {
        case 'By State': {
          return 'State'
        }
        case 'By Lane': {
          return 'Zone To'
        }
        case 'By Carrier': {
          return 'Carrier Name'
        }
        case 'By Service': {
          return 'Service Name'
        }
        case 'By Branch': {
          return 'Branch Name'
        }
      }
    },
    getYKeyByChart (chart) {
      switch (chart) {
        case 'Consignments': {
          return 'Connotes'
        }
        case 'Items': {
          return 'No Items'
        }
        case 'Cube': {
          return 'Cube (m3)'
        }
        case 'Weight': {
          return 'Weight (Kg)'
        }
        case 'Billed': {
          return 'Billed Price'
        }
        case 'Estimated': {
          return 'Est. Price'
        }
      }
    },
    getReportByChart (chart) {
      switch (chart) {
        case 'Consignments': {
          return 'FreightSummaryBranch'
        }
        case 'Items': {
          return 'FreightSummaryBranch'
        }
        case 'Cube': {
          return 'FreightSummaryBranch'
        }
        case 'Weight': {
          return 'FreightSummaryBranch'
        }
        case 'Billed': {
          return 'FreightSummaryBranch'
        }
        case 'Estimated': {
          return 'FreightSummaryBranch'
        }
      }
    },
    remoteMethodAccount (query) {
      this.isLoadingAccounts = true
      this.$sdk.account.list(builder => {
        builder.filters = { account_name: query, account_active: 1 }
      }).then(res => {
        this.accounts = res
      }).finally(() => { this.isLoadingAccounts = false })
    },
    remoteMethodCarrier (query) {
      this.isLoadingCarriers = true
      this.$sdk.carrier.list(builder => {
        builder.filters = { 'carrier_name': query }
      }).then(res => {
        this.carriers = res
      }).finally(() => { this.isLoadingCarriers = false })
    }
  }
}
</script>
